import * as Inovx from '@shared';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/UserApi/api/user`;

var UserServices: IUserService = { ...Inovx.Shared.Flux.BaseService, ...{
    getAll: function (successCallback: (retData: IUser[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(url,
            null,
            (retData: any) => {
                successCallback(retData);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    createUser: function (user: IUser, successCallback: () => void, errorCallback: IErrorCallback, ignoreDefaultError: (error: IServiceErrorObject) => boolean) {
        this.post(`${url}/Create`,
            user,
            (data: any) => {
                successCallback();
            },
            (error: IServiceErrorObject) => {
                if (!ignoreDefaultError(error)) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    deleteUser: function (user: IUser, successCallback: () => void, errorCallback: IErrorCallback) {
        this.post(`${url}/Delete`,
            { id: user.UserID, versionToken: user.UserVersionToken },
            (data: any) => {
                successCallback();
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    editUser: function (user: IUser, successCallback: () => void, errorCallback: IErrorCallback, ignoreDefaultError: (error: IServiceErrorObject) => boolean) {
        this.post(`${url}/Update`,
            user,
            (data: any) => {
                successCallback();
            },
            (error: any) => {
                if (!ignoreDefaultError(error)) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    getDetail: function (userId: string, successCallback: (data: IUserDetails) => void, errorCallback: IErrorCallback) {
        this.post(`${url}/GetDetails`,
            { UserId: userId },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    getLinkedEntitlementGroups: function (externalAccountID: string, successCallback: (data: string[]) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/LinkedEntitlementGroups`,
            { ExternalAccountID: externalAccountID },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    getLinkedRoles: function (externalAccountID: string, successCallback: (data: string[]) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/LinkedRoles`,
            { ExternalAccountID: externalAccountID },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    synchronizeLinkedGroups: function (successCallback: () => void, errorCallback: IErrorCallback) {
        this.post(`${url}/SynchronizeLinkedGroups`,
            null,
            () => {
                successCallback();
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    getCurrentUserDetail: function (successCallback: (data: IUserDetails) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/GetCurrentUserDetails`,
            null,
            (data: IUserDetails) => {
                successCallback(data);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    changePassword: function (user: IUser, password: string, successCallback: (data: IUser) => void, errorCallback: IErrorCallback, ignoreDefaultError: (error: IServiceErrorObject) => boolean) {
        this.post(`${url}/ChangePassword`,
            { UserId: user.UserID, UserVersionToken: user.UserVersionToken, Password: password },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                if (!ignoreDefaultError(error)) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    resetPasswords: function (successCallback: () => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.post(`${url}/InvalidatePasswords`,
            null,
            (data: any) => {
                successCallback();
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    checkName: function (hint: string, successCallback: (data: IUser[]) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/QueryDirectory`,
            { nameHint: hint },
            (data: any) => {
                successCallback(data);
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    resetLoginAttempts: function (user: IUser, successCallback: () => void, errorCallback: IErrorCallback) {
        this.post(`${url}/ResetLoginAttempts`,
            { id: user.UserID },
            (data: any) => {
                successCallback();
            },
            (error: any) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    getEntitlements: function (successCallback: (data: IEntitlementGroup[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/EntitlementGroups`,
            null,
            (data: IEntitlementGroup[]) => {
                successCallback(data);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    getRoles: function (successCallback: (data: IRole[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/Roles`,
            null,
            (data: IRole[]) => {
                successCallback(data);
            },
            (error: any) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    }
}};

export default UserServices;
